import { createSlice } from '@reduxjs/toolkit'
import { differenceWith, unionBy } from 'lodash'
import { current } from '@reduxjs/toolkit'
import { isEmpty } from 'lodash'

const initialState = {
  loading: false,
  error: '',
  processing: false,
  promoEvents: [],
  newPromoEvent: {},
  success: false,
  eventDoctorAssociationInfo: {}, }

const promoEventSlice = createSlice({
  name: 'promoEventSlice',
  initialState: initialState,
  reducers: {
    fetchPromoEventList: () => {},
    togglePromoEventStatus: () => {},
    createPromoEvent: () => {},
    fetchEventDoctorAssociation: () => {},
    associateEventDoctor: () => {},
    setLoading: (state) => {
      state.loading = true
      state.success = false
    },
    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
    },
    setProcessing: (state, action) => {
      state.processing = action?.payload ?? true
      state.success = false
    },
    setPromoEventList: (state, action) => {
      state.promoEvents = action.payload
      state.loading = false
    },
    setSuccess: (state) => {
      state.success = true
      state.processing = false
    },
    setNewPromoEvent: (state, action) => {
      state.promoEvents.push(action.payload)
      state.newPromoEvent = action.payload
      state.processing = false
    },
    setEventDoctorAssociationInfo: (state, action) => {
      state.loading = false
      state.eventDoctorAssociationInfo = action.payload
    },
    setAssociatedDoctorToEvent: (state, action) => {
      const { payload, selectedDoctors } = action.payload
      if (payload.action === 'ADD') {
        return {
          ...state,
          loading: false,
          eventDoctorAssociationInfo: {
            ...state.eventDoctorAssociationInfo,
            doctors: unionBy(
              current(state.eventDoctorAssociationInfo.doctors),
              selectedDoctors,
              'mobile'
            ),
          },
        }
      } else {
        return {
          ...state,
          loading: false,
          eventDoctorAssociationInfo: {
            ...state.eventDoctorAssociationInfo,
            doctors: differenceWith(
              state.eventDoctorAssociationInfo.doctors,
              payload.ids,
              (doctor, id) => doctor.id === id,
            ),
          },
        }
      }
    },
  },
})

export const {
  setLoading,
  setError,
  setProcessing,
  fetchPromoEventList,
  togglePromoEventStatus,
  createPromoEvent,
  setPromoEventList,
  setSuccess,
  setNewPromoEvent,
  setEventDoctorAssociationInfo,
  fetchEventDoctorAssociation,
  associateEventDoctor,
  setAssociatedDoctorToEvent,
} = promoEventSlice.actions
export default promoEventSlice.reducer
